import { createContext, Dispatch, useReducer } from 'react';
import { initialState } from './ProgramsListState';
import { IProgramsListActions, actions } from './ProgramsListActions';
import { ProgramListReducer } from './ProgramsListReducer';
import { IProgramsListStates } from './ProgramsListState';
import React from 'react';

export interface IProgramsListContext {
  state: IProgramsListStates;
  actions: IProgramsListActions;
  dispatch: Dispatch<any>;
}

interface IProps {
  children: JSX.Element[] | JSX.Element;
}

export const ProgramsListContext = createContext<IProgramsListContext>({} as IProgramsListContext);

const ProgramListProvider = ({ children }: IProps) => {
  const [state, dispatch] = useReducer(ProgramListReducer, initialState);

  return (
    <ProgramsListContext.Provider value={{ state, actions, dispatch }}>
      {children}
    </ProgramsListContext.Provider>
  );
};

export default ProgramListProvider;
